import _ from 'underscore';
import { INotification, TargetComponent, NotificationLevel, DismissMode, ScopeLevel, IContext } from '../../types';
import { isBillingLinkPermission } from '../../utils';

const notificationTitle = _TL_('Important updates about the Hotel Center Deprecation');
const notificationMessage = _TL_('As of April 9th, you’ll no longer have full access to Hotel Center for your campaign management. You can continue to manage your feeds through Hotel Center; otherwise, please use {{lodgingCampaignPrefix}}Lodging campaigns{{lodgingCampaignSuffix}} to manage your Hotel Price ads and Property Promotion ads. {{br2}}{{guideLinkPrefix}}Read more about how you can make your migration process smoother{{guideLinkSuffix}}.');

export class HotelCenterMigrationPhase3Notification {
  context: IContext;
  i18n: any;
  availableScopes: ScopeLevel[];

  constructor(context: IContext) {
    this.context = context;
    this.i18n = context.getNewI18n();
    this.availableScopes = [ScopeLevel.account, ScopeLevel.customer];
  }

  async getHotelCenterMigrationPhase3Notifications() {
    if (!this.context.getUserContext().CurrentUser.IsInternal && isBillingLinkPermission(this.context.getSettingsContext())) {
      return [];
    }

    const currentPermissions = this.context.getCurrentPermissions();
    const isHotelCenterEnabled = currentPermissions && currentPermissions.dynamic.HotelAds;
    const isHotelCenterRemovalEnabled = currentPermissions && currentPermissions.dynamic.HotelCenterRemoval;
    if (!isHotelCenterEnabled || isHotelCenterRemovalEnabled) {
      return [];
    }

    const replaceMap = {
      br: '<br/>',
      br2: '<br/><br/>',
      lodgingCampaignPrefix: '<a href="https://help.ads.microsoft.com/#apex/ads/en/60154/1" target="_blank">',
      lodgingCampaignSuffix: '</a>',
      guideLinkPrefix: '<a href="https://about.ads.microsoft.com/en-us/blog/post/january-2024/upcoming-changes-to-hotel-center-subaccounts" target="_blank">',
      guideLinkSuffix: '</a>',
    };

    let finalMessage = this.i18n.getString(notificationMessage);
    Object.keys(replaceMap).forEach((key) => {
      finalMessage = finalMessage.replaceAll(`{{${key}}}`, replaceMap[key]);
    });

    // Get notifications
    const notifications: INotification[] = [{
      id: 'HotelCenterPhase3Migration',
      condition: true,
      target: TargetComponent.UnifiedQueue,
      dismissMode: DismissMode.session,
      severity: NotificationLevel.Info,
      scopeLevel: ScopeLevel.account,
      availableScopes: this.availableScopes,
      title: this.i18n.getString(notificationTitle),
      message: finalMessage,
      actionList: [],
    }];


    return _.compact(notifications);
  }
}
